import React from 'react';
import {withRouter} from "react-router-dom";
import {Col, Row} from "reactstrap";
import {Button, Form, Radio, Select as Cselect} from "semantic-ui-react";
import './create_work_space_style.scss';
import {MDBModal, MDBModalBody, MDBModalHeader} from "mdbreact";
import moment from 'moment';
import Cookies from "js-cookie";
import axiosTags from "../../../axios/axios_tag";
import apiConfig from "../../../axios/axios_api_services";
import * as common from "../../../const/Common/CommonFunc";
import * as actionCreator from "../../../store/Action";
import {connect} from "react-redux";
import swal from "sweetalert";
import are_you_sure_icon from "../../../assets/img/sweet/question.svg";
import * as time_convertor_utils from '../../../util/TimeConvertor';

const format = 'HH:mm';

const options = [
  { value: 'chocolate', label: 'Chocolate' },
  { value: 'strawberry', label: 'Strawberry' },
  { value: 'vanilla', label: 'Vanilla' }
];

class CreateWorkSpace extends React.Component {

  state = {
    all_branch_list: [],
    all_building_list: [],
    branch_options: [],
    building_options: [],
    floor_options: [],
    user_group_options: [],
    selected_user_groups: [],

    workspace_name: "",
    branch: "",
    building: "",
    floor: "",
    user_group: "",
    slot_count: 0,

    openMonTime: "00:00",
    closeMonTime: "23:59",
    activeMonTime: true,

    openTuesTime: "00:00",
    closeTuesTime: "23:59",
    activeTuesTime: true,

    openWedTime: "00:00",
    closeWedTime: "23:59",
    activeWedTime: true,

    openThursTime: "00:00",
    closeThursTime: "23:59",
    activeThursTime: true,

    openFriTime: "00:00",
    closeFriTime: "23:59",
    activeFriTime: true,

    openSatTime: "00:00",
    closeSatTime: "23:59",
    activeSatTime: true,

    openSunTime: "00:00",
    closeSunTime: "23:59",
    activeSunTime: true,

  };

  componentDidMount() {

    this.getBranchesByCorporateId();
    this.getUserGroupsByCorporateId();

  }

  getUserGroupsByCorporateId = () => {
      let corporateId = this.props.usr_obj.corporates[0].corporateId;
      const headers = {
        "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
      };
      this.props.spinnerHandler(true);
      if(corporateId !== -1 && corporateId !== null && corporateId !== undefined) {
        axiosTags.get(apiConfig.CORPORATE_USER_GROUPS( corporateId, 5000),{headers:headers}).then(r =>{
          if(r.data.success) {
            let user_groups_options = [];
            r.data.userGroups.map((result, index)=>{
              const obj = {
                key: index,
                text: result.groupName,
                value: result.userGroupId,
              };
              user_groups_options.push(obj);
            });
            this.setState({
              user_group_options: user_groups_options
            });
          }
        }).catch(async error => {
          let result = await common.checkErrorResponse(error);
          if (result === 1) {
            this.getUserGroupsByCorporateId()
          }
        }).finally(fin => {
          this.props.spinnerHandler(false);
        });
    };

  };

  getBranchesByCorporateId = () => {
      const headers = {
        "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
      };

      this.props.spinnerHandler(true);
      axiosTags.get(apiConfig.CORPORATE_BRANCH(this.props.usr_obj.corporateId), {headers: headers})
        .then(response => {
          if (response.data.success) {
            let branch_options = [];
            if (response.data.branchList.length !== 0) {
              response.data.branchList.map((branch, index) => {

                const obj = {
                  key: index,
                  text: branch.name,
                  value: index,
                  // value: branch.branchId
                };
                branch_options.push(obj)
              })
            }
            this.setState({
              branch_options: branch_options,
              all_branch_list: response.data.branchList
            })
          } else {
            this.setState({
              branch_options: []
            })
          }
        })
        .catch(async error => {
          let result = await common.checkErrorResponse(error);
          if (result === 1) {
            this.getBranchesByCorporateId()
          }
        })
        .finally(fin => {
          this.props.spinnerHandler(false);
        });
  };


  getBuildingsByBranchId = (index) => {
    let building_options = [];
    let buildings = null;
    let branchOptions = this.state.all_branch_list;
    if(branchOptions) {
      let branchOption = branchOptions[index];
      buildings = branchOption.buildings;
      if(buildings) {
        buildings.map((result, index)=>{
          const obj = {
            key: index,
            text: result.name,
            value: index,
          };
          building_options.push(obj);
        });
      }
    }
    this.setState({
      building_options: building_options,
      all_building_list: buildings
    });
  };

  getFloorsByBuildingId = (index) => {
    let floor_options = [];
    let floorOptions = this.state.all_building_list;
    if(floorOptions) {
      let floorOption = floorOptions[index];
      let floors = floorOption.floors;
      if(floors) {
        floors.map((result, index)=>{
          const obj = {
            key: index,
            text: result.description,
            value: result.floor_id,
          };
          floor_options.push(obj);
        });
      }
    }
    this.setState({
      floor_options: floor_options,
    });
  };

  onChangeWorkspaceName = event => {
    let value = event.target.value;
    this.setState({
      workspace_name: value
    });
  };

  onChangeSlotCount = event => {
    let value = event.target.value;
    this.setState({
      slot_count: value
    });
  };

  onChangeBranch = (e, {value}) => {
    this.setState({
      branch: value,
      building: "",
      floor: "",
      floor_options: []
    });
    this.getBuildingsByBranchId(value);
  };

  onChangeBuilding = (e, {value}) => {
    this.setState({
      building: value
    });
    this.getFloorsByBuildingId(value);
  };

  onChangeFloor = (e, {value}) => {
    this.setState({
      floor: value
    });
  };

  onChangeUserGroup = (e, {value}) => {
    this.setState({
      selected_user_groups: value
    });
  };

  onChangeTime_Mon_O = ( time, timeString ) => {
    this.setState({
      openMonTime: timeString,
      // closeMonTime: value,
    });
  };

  onChangeTime_Mon_C = ( time, timeString ) => {
    this.setState({
      // openMonTime: value,
      closeMonTime: timeString,
    });
  };

  onChangeTime_Tue_O = ( time, timeString ) => {
    this.setState({
      openTuesTime: timeString,
      // closeTuesTime: value,
    });
  };

  onChangeTime_Tue_C = ( time, timeString ) => {
    this.setState({
      // openTuesTime: value,
      closeTuesTime: timeString,
    });
  };

  onChangeTime_Wed_O = ( time, timeString ) => {
    this.setState({
      openWedTime: timeString,
      // closeWedTime: value,
    });
  };

  onChangeTime_Wed_C = ( time, timeString ) => {
    this.setState({
      // openWedTime: value,
      closeWedTime: timeString,
    });
  };

  onChangeTime_Thu_O = ( time, timeString ) => {
    this.setState({
      openThursTime: timeString,
      // closeThursTime: value,
    });
  };

  onChangeTime_Thu_C = ( time, timeString ) => {
    this.setState({
      // openThursTime: value,
      closeThursTime: timeString,
    });
  };

  onChangeTime_Fri_O = ( time, timeString ) => {
    this.setState({
      openFriTime: timeString,
      // closeSatTime: value,
    });
  };

  onChangeTime_Fri_C = ( time, timeString ) => {
    this.setState({
      // openFriTime: value,
      closeFriTime: timeString,
    });
  };

  onChangeTime_Sat_O = ( time, timeString ) => {
    this.setState({
      openSatTime: timeString,
      // closeSatTime: value,
    });
  };

  onChangeTime_Sat_C = ( time, timeString ) => {
    this.setState({
      // openSatTime: value,
      closeSatTime: timeString,
    });
  };

  onChangeTime_Sun_O = ( time, timeString ) => {
    this.setState({
      openSunTime: timeString,
      // closeSunTime: value,
    });
  };

  onChangeTime_Sun_C = ( time, timeString ) => {
    this.setState({
      // openSunTime: value,
      closeSunTime: timeString,
    });
  };

  onChangeActivation = (day) => {
    switch (day) {
      case "MON":
        if(this.state.activeMonTime) {
          this.setState({
            // openMonTime: null,
            // closeMonTime: null,
            activeMonTime: !this.state.activeMonTime
          });
        } else {
          this.setState({
            activeMonTime: !this.state.activeMonTime
          });
        }
        break;
      case "TUE":
        if(this.state.activeTuesTime) {
          this.setState({
            // openTuesTime: null,
            // closeTuesTime: null,
            activeTuesTime: !this.state.activeTuesTime
          });
        } else {
          this.setState({
            activeTuesTime: !this.state.activeTuesTime
          });
        }
        break;
      case "WED":
        if(this.state.activeWedTime) {
          this.setState({
            // openWedTime: null,
            // closeWedTime: null,
            activeWedTime: !this.state.activeWedTime
          });
        } else {
          this.setState({
            activeWedTime: !this.state.activeWedTime
          });
        }
        break;
      case "THU":
        if(this.state.activeThursTime) {
          this.setState({
            // openThursTime: null,
            // closeThursTime: null,
            activeThursTime: !this.state.activeThursTime
          });
        } else {
          this.setState({
            activeThursTime: !this.state.activeThursTime
          });
        }
        break;
      case "FRI":
        if(this.state.activeFriTime) {
          this.setState({
            // openFriTime: null,
            // closeFriTime: null,
            activeFriTime: !this.state.activeFriTime
          });
        } else {
          this.setState({
            activeFriTime: !this.state.activeFriTime
          });
        }
        break;
      case "SAT":
        if(this.state.activeSatTime) {
          this.setState({
            // openSatTime: null,
            // closeSatTime: null,
            activeSatTime: !this.state.activeSatTime
          });
        } else {
          this.setState({
            activeSatTime: !this.state.activeSatTime
          });
        }
        break;
      case "SUN":
        if(this.state.activeSunTime) {
          this.setState({
            // openSunTime: null,
            // closeSunTime: null,
            activeSunTime: !this.state.activeSunTime
          });
        } else {
          this.setState({
            activeSunTime: !this.state.activeSunTime
          });
        }
        break;
    }
  };


  createWorkSpace = () => {
    this.state.workspace_name.trim() === ''? common.notifyMessage("Please enter workspace name"):
      this.state.branch === ''? common.notifyMessage("Please select branch"):
        this.state.building === ''? common.notifyMessage("Please select building"):
          this.state.floor === ''? common.notifyMessage("Please select floor"):
            this.state.selected_user_groups.length === 0? common.notifyMessage("Please select employee group"):
              this.state.slot_count === 0? common.notifyMessage("Please enter slot count"):
                // this.createWorkSpace_MO();
                this.checkOPenDates();
  };

  createWorkSpace_MO = () => {
    if(this.state.activeMonTime) {
      if(this.state.openMonTime !== null) {
        if(this.state.closeMonTime !== null) {
          moment(this.state.openMonTime,'HH:mm:ss').isAfter(moment(this.state.closeMonTime,'HH:mm:ss'))?
            common.notifyMessage("Please enter valid open and close time to monday"): this.createWorkSpace_TUS();
        } else {
          common.notifyMessage("Please enter monday close time");
        }
      }  else {
        common.notifyMessage("Please enter monday open time");
      }
    } else {
      this.createWorkSpace_TUS();
    }
  };

  createWorkSpace_TUS = () => {
    if(this.state.activeTuesTime) {
      if(this.state.openTuesTime !== null) {
        if(this.state.closeTuesTime !== null) {
          moment(this.state.openTuesTime,'HH:mm:ss').isAfter(moment(this.state.closeTuesTime,'HH:mm:ss'))?
            common.notifyMessage("Please enter valid open and close time to tuesday"):this.createWorkSpace_WED();
        } else {
          common.notifyMessage("Please enter tuesday close time");
        }
      }  else {
        common.notifyMessage("Please enter tuesday open time");
      }
    } else {
      this.createWorkSpace_WED();
    }
  };

  createWorkSpace_WED = () => {
    if(this.state.activeWedTime) {
      if(this.state.openWedTime !== null) {
        if(this.state.closeWedTime !== null) {
          moment(this.state.openWedTime,'HH:mm:ss').isAfter(moment(this.state.closeWedTime,'HH:mm:ss'))?
            common.notifyMessage("Please enter valid open and close time to wednesday"):this.createWorkSpace_THU();
        } else {
          common.notifyMessage("Please enter wednesday close time");
        }
      }  else {
        common.notifyMessage("Please enter wednesday open time");
      }
    } else {
      this.createWorkSpace_THU();
    }
  };

  createWorkSpace_THU = () => {
    if(this.state.activeThursTime) {
      if(this.state.openThursTime !== null) {
        if(this.state.closeThursTime !== null) {
          moment(this.state.openThursTime,'HH:mm:ss').isAfter(moment(this.state.closeThursTime,'HH:mm:ss'))?
            common.notifyMessage("Please enter valid open and close time to thursday"):this.createWorkSpace_FRI();
        } else {
          common.notifyMessage("Please enter thursday close time");
        }
      }  else {
        common.notifyMessage("Please enter thursday open time");
      }
    } else {
      this.createWorkSpace_FRI();
    }
  };

  createWorkSpace_FRI = () => {
    if(this.state.activeFriTime) {
      if(this.state.openFriTime !== null) {
        if(this.state.closeFriTime !== null) {
          moment(this.state.openFriTime,'HH:mm:ss').isAfter(moment(this.state.closeFriTime,'HH:mm:ss'))?
            common.notifyMessage("Please enter valid open and close time to friday"):this.createWorkSpace_SAT();
        } else {
          common.notifyMessage("Please enter friday close time");
        }
      }  else {
        common.notifyMessage("Please enter friday open time");
      }
    } else {
      this.createWorkSpace_SAT();
    }
  };

  createWorkSpace_SAT = () => {
    if(this.state.activeSatTime) {
      if(this.state.openSatTime !== null) {
        if(this.state.closeSatTime !== null) {
          moment(this.state.openSatTime,'HH:mm:ss').isAfter(moment(this.state.closeSatTime,'HH:mm:ss'))?
            common.notifyMessage("Please enter valid open and close time to saturday"):this.createWorkSpace_SUN();
        } else {
          common.notifyMessage("Please enter saturday close time");
        }
      }  else {
        common.notifyMessage("Please enter saturday open time");
      }
    } else {
      this.createWorkSpace_SUN();
    }
  };

  createWorkSpace_SUN = () => {
    if(this.state.activeSunTime) {
      if(this.state.openSunTime !== null) {
        if(this.state.closeSunTime !== null) {
          moment(this.state.openSunTime,'HH:mm:ss').isAfter(moment(this.state.closeSunTime,'HH:mm:ss'))?
            common.notifyMessage("Please enter valid open and close time to sunday"):this.createWorkSpace_();
        } else {
          common.notifyMessage("Please enter sunday close time");
        }
      }  else {
        common.notifyMessage("Please enter sunday open time");
      }
    } else {
      this.createWorkSpace_();
    }
  };

  // after removing time inputs, use this validation
  checkOPenDates = () => {
    if (
      !(this.state.activeMonTime ||
        this.state.activeTuesTime ||
        this.state.activeWedTime ||
        this.state.activeThursTime ||
        this.state.activeFriTime ||
        this.state.activeSatTime ||
        this.state.activeSunTime
      )) {
      common.notifyMessage("Please select open days");
    } else {
      this.createWorkSpace_();
    }
  };

  createWorkSpace_ = () => {
    swal({
      title: "Do you want to create workspace named " + this.state.workspace_name + "?",
      icon: are_you_sure_icon,
      closeOnClickOutside: false,
      buttons: {
        cancel: 'Cancel',
        dangerMode: {
          text: "Yes",
          value: "action",
          className: "okay-btn"
        }
      },
    })
      .then((value) => {
        switch (value) {
          case "action":
            this.sendToBackend();
            break;
          default:
        }
      });
  };

  sendToBackend = () => {

    let selectedUserGroupList = this.state.selected_user_groups;
    // let selectedUserGroups = this.state.selected_user_groups;
    // if(selectedUserGroups) {
    //   selectedUserGroups.map((result, index)=>{
    //     selectedUserGroupList.push(result.value);
    //   });
    // }

    let obj =
      {
        workSpaceId: 0,
        description: this.state.workspace_name,
        status: "OPEN",

        openMonTime: this.state.activeMonTime?time_convertor_utils.HHMMSSLocalToUTC( this.state.openMonTime + ":00" ):null,
        closeMonTime: this.state.activeMonTime?time_convertor_utils.HHMMSSLocalToUTC( this.state.closeMonTime + ":59" ):null,

        openTuesTime: this.state.activeTuesTime?time_convertor_utils.HHMMSSLocalToUTC( this.state.openTuesTime + ":00" ):null,
        closeTuesTime: this.state.activeTuesTime?time_convertor_utils.HHMMSSLocalToUTC( this.state.closeTuesTime + ":59" ):null,

        openWedTime: this.state.activeWedTime?time_convertor_utils.HHMMSSLocalToUTC( this.state.openWedTime + ":00" ):null,
        closeWedTime: this.state.activeWedTime?time_convertor_utils.HHMMSSLocalToUTC( this.state.closeWedTime + ":59"):null,

        openThursTime: this.state.activeThursTime?time_convertor_utils.HHMMSSLocalToUTC( this.state.openThursTime + ":00" ):null,
        closeThursTime: this.state.activeThursTime?time_convertor_utils.HHMMSSLocalToUTC( this.state.closeThursTime + ":59" ):null,

        openFriTime: this.state.activeFriTime?time_convertor_utils.HHMMSSLocalToUTC( this.state.openFriTime + ":00" ):null,
        closeFriTime: this.state.activeFriTime?time_convertor_utils.HHMMSSLocalToUTC( this.state.closeFriTime + ":59" ):null,

        openSatTime: this.state.activeSatTime?time_convertor_utils.HHMMSSLocalToUTC( this.state.openSatTime + ":00" ):null,
        closeSatTime: this.state.activeSatTime?time_convertor_utils.HHMMSSLocalToUTC( this.state.closeSatTime + ":59" ):null,

        openSunTime: this.state.activeSunTime?time_convertor_utils.HHMMSSLocalToUTC( this.state.openSunTime + ":00" ):null,
        closeSunTime: this.state.activeSunTime?time_convertor_utils.HHMMSSLocalToUTC( this.state.closeSunTime + ":59" ):null,

        fkFloorId: this.state.floor,
        totalSlotCount: this.state.slot_count,
        todaySlotBookedCount: 0,
        userGroupList: selectedUserGroupList
      };

    let corporateId = this.props.usr_obj.corporates[0].corporateId;

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    this.props.spinnerHandler(true);
    axiosTags.put(apiConfig.ST_CREATE_WORKSPACE({corporateId:corporateId}), obj, {headers: headers})
      .then(response => {
        if (response.data.success) {
          this.props.spinnerHandler(false);
          common.warningAlert(this.state.workspace_name + " workspace had created successfully!", 0);
          this.props.closeModal();
        } else {
          common.warningAlert("Oops! something was wrong, please try again!", 1);
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.sendToBackend();
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });

  };

  toggle = () => {};

  render() {

    let {

      branch_options,
      user_group_options,
      selected_user_groups,

      workspace_name,
      slot_count,
      activeMonTime,

      activeTuesTime,

      activeWedTime,

      activeThursTime,

      activeFriTime,

      activeSatTime,

      activeSunTime,

    } = this.state;

    let activation_mon = !activeMonTime;
    let activation_tue = !activeTuesTime;
    let activation_wed = !activeWedTime;
    let activation_thu = !activeThursTime;
    let activation_fri = !activeFriTime;
    let activation_sat = !activeSatTime;
    let activation_sun = !activeSunTime;

    return(
      <div>
        <MDBModal isOpen={this.props.isOpen} toggle={this.toggle} size="lg">
          <MDBModalHeader className={"title"}
                          toggle={this.props.closeModal}>Create New Workspace</MDBModalHeader>
          <MDBModalBody>

            <div className={'create-work-space-content'}>
              <Row>
                <Col sm={12} md={12} lg={6} xl={6}>
                  <Form>
                    <Form.Field>
                      <label>Workspace Name</label>
                      <input
                        placeholder='Work Space Name'
                        value={ workspace_name }
                        onChange={ this.onChangeWorkspaceName }
                      />
                    </Form.Field>
                    <Form.Field>
                      <label>Branch</label>
                      <Cselect
                        placeholder='Select branch'
                        value={ this.state.branch }
                        options={ branch_options }
                        onChange={ this.onChangeBranch }
                      />
                    </Form.Field>
                    <Form.Field>
                      <label>Building</label>
                      <Cselect
                        placeholder='Select building'
                        value={ this.state.building }
                        options={ this.state.building_options }
                        onChange={ this.onChangeBuilding }
                      />
                    </Form.Field>
                    <Form.Field>
                      <label>Floor</label>
                      <Cselect
                        placeholder='Select Floor'
                        value={ this.state.floor }
                        options={ this.state.floor_options }
                        onChange={ this.onChangeFloor }
                      />
                    </Form.Field>
                    <Form.Group>
                      <Form.Field width={12}>
                        <label>Employee group</label>

                        <Cselect
                          placeholder='Select User Groups'
                          value={ selected_user_groups }
                          options={ user_group_options }
                          multiple
                          search
                          selection
                          onChange={ this.onChangeUserGroup }
                        />

                        {/*<Select*/}
                        {/*  closeMenuOnSelect={true}*/}
                        {/*  // components={animatedComponents}*/}
                        {/*  defaultValue={selected_user_groups}*/}
                        {/*  isMulti*/}
                        {/*  options={ user_group_options }*/}
                        {/*  onChange={this.onChangeUserGroup}*/}
                        {/*/>*/}
                      </Form.Field>
                      <Form.Field width={4}>
                        <label>Slot count</label>
                        <input
                          type='number'
                          placeholder='Slot count'
                          value={ slot_count }
                          onChange={ this.onChangeSlotCount }
                        />
                      </Form.Field>
                    </Form.Group>
                  </Form>
                </Col>
                <Col sm={12} md={12} lg={6} xl={6}>
                  <div className={'lbl-title create-open-close-title'}>Open and close days</div>

                  <div>

                    <table className={ 'create-open-close-time-tbl' }>
                      <tbody>
                        <tr className={'open-close-time-row'}>
                          <td className={'open-close-time-cell'}>
                            <div className={'lbl-title'}>Mon</div>
                          </td>
                          <td className={'open-close-time-cell'}>
                            <div>
                              <Radio toggle defaultChecked={ activeMonTime } onChange={ ()=>this.onChangeActivation("MON") } />
                            </div>
                          </td>
                          {/*<td className={'open-close-time-cell'}>*/}
                          {/*  <div>{" From "}</div>*/}
                          {/*</td>*/}
                          {/*<td className={'open-close-time-cell'}>*/}
                          {/*  <div>*/}
                          {/*    <TimePicker defaultValue={(openMonTime===null||openMonTime===undefined||openMonTime==="")?null:moment(openMonTime, format)} format={format} disabled={ activation_mon } onChange={ this.onChangeTime_Mon_O } />*/}
                          {/*  </div>*/}
                          {/*</td>*/}
                          {/*<td className={'open-close-time-cell'}>*/}
                          {/*  <div>{" To "}</div>*/}
                          {/*</td>*/}
                          {/*<td className={'open-close-time-cell'}>*/}
                          {/*  <div>*/}
                          {/*    <TimePicker defaultValue={(closeMonTime===null||closeMonTime===undefined||closeMonTime==="")?null:moment(closeMonTime, format)} format={format} disabled={ activation_mon } onChange={ this.onChangeTime_Mon_C } />*/}
                          {/*  </div>*/}
                          {/*</td>*/}
                        </tr>
                        <tr className={'open-close-time-row'}>
                          <td className={'open-close-time-cell'}>
                            <div className={'lbl-title'}>Tue</div>
                          </td>
                          <td className={'open-close-time-cell'}>
                            <div>
                              <Radio toggle defaultChecked={ activeTuesTime } onChange={ ()=>this.onChangeActivation("TUE") } />
                            </div>
                          </td>
                          {/*<td className={'open-close-time-cell'}>*/}
                          {/*  <div>{" From "}</div>*/}
                          {/*</td>*/}
                          {/*<td className={'open-close-time-cell'}>*/}
                          {/*  <div>*/}
                          {/*    <TimePicker defaultValue={(openTuesTime===null||openTuesTime===undefined||openTuesTime==="")?null:moment(openTuesTime, format)} format={format} disabled={ activation_tue } onChange={ this.onChangeTime_Tue_O } />*/}
                          {/*  </div>*/}
                          {/*</td>*/}
                          {/*<td className={'open-close-time-cell'}>*/}
                          {/*  <div>{" To "}</div>*/}
                          {/*</td>*/}
                          {/*<td className={'open-close-time-cell'}>*/}
                          {/*  <div>*/}
                          {/*    <TimePicker defaultValue={(closeTuesTime===null||closeTuesTime===undefined||closeTuesTime==="")?null:moment(closeTuesTime, format)} format={format} disabled={ activation_tue } onChange={ this.onChangeTime_Tue_C } />*/}
                          {/*  </div>*/}
                          {/*</td>*/}
                        </tr>
                        <tr className={'open-close-time-row'}>
                          <td className={'open-close-time-cell'}>
                            <div className={'lbl-title'}>Wed</div>
                          </td>
                          <td className={'open-close-time-cell'}>
                            <div>
                              <Radio toggle defaultChecked={ activeWedTime } onChange={ ()=>this.onChangeActivation("WED") } />
                            </div>
                          </td>
                          {/*<td className={'open-close-time-cell'}>*/}
                          {/*  <div>{" From "}</div>*/}
                          {/*</td>*/}
                          {/*<td className={'open-close-time-cell'}>*/}
                          {/*  <div>*/}
                          {/*    <TimePicker defaultValue={(openWedTime===null||openWedTime===undefined||openWedTime==="")?null:moment(openWedTime, format)} format={format} disabled={ activation_wed } onChange={ this.onChangeTime_Wed_O } />*/}
                          {/*  </div>*/}
                          {/*</td>*/}
                          {/*<td className={'open-close-time-cell'}>*/}
                          {/*  <div>{" To "}</div>*/}
                          {/*</td>*/}
                          {/*<td className={'open-close-time-cell'}>*/}
                          {/*  <div>*/}
                          {/*    <TimePicker defaultValue={(closeWedTime===null||closeWedTime===undefined||closeWedTime==="")?null:moment(closeWedTime, format)} format={format} disabled={ activation_wed } onChange={ this.onChangeTime_Wed_C } />*/}
                          {/*  </div>*/}
                          {/*</td>*/}
                        </tr>
                        <tr className={'open-close-time-row'}>
                          <td className={'open-close-time-cell'}>
                            <div className={'lbl-title'}>Thu</div>
                          </td>
                          <td className={'open-close-time-cell'}>
                            <div>
                              <Radio toggle defaultChecked={ activeTuesTime } onChange={ ()=>this.onChangeActivation("THU") } />
                            </div>
                          </td>
                          {/*<td className={'open-close-time-cell'}>*/}
                          {/*  <div>{" From "}</div>*/}
                          {/*</td>*/}
                          {/*<td className={'open-close-time-cell'}>*/}
                          {/*  <div>*/}
                          {/*    <TimePicker defaultValue={(openThursTime===null||openThursTime===undefined||openThursTime==="")?null:moment(openThursTime, format)} format={format} disabled={ activation_thu } onChange={ this.onChangeTime_Thu_O } />*/}
                          {/*  </div>*/}
                          {/*</td>*/}
                          {/*<td className={'open-close-time-cell'}>*/}
                          {/*  <div>{" To "}</div>*/}
                          {/*</td>*/}
                          {/*<td className={'open-close-time-cell'}>*/}
                          {/*  <div>*/}
                          {/*    <TimePicker defaultValue={(closeThursTime===null||closeThursTime===undefined||closeThursTime==="")?null:moment(closeThursTime, format)} format={format} disabled={ activation_thu } onChange={ this.onChangeTime_Thu_C } />*/}
                          {/*  </div>*/}
                          {/*</td>*/}
                        </tr>
                        <tr className={'open-close-time-row'}>
                          <td className={'open-close-time-cell'}>
                            <div className={'lbl-title'}>Fri</div>
                          </td>
                          <td className={'open-close-time-cell'}>
                            <div>
                              <Radio toggle defaultChecked={ activeFriTime } onChange={ ()=>this.onChangeActivation("FRI") } />
                            </div>
                          </td>
                          {/*<td className={'open-close-time-cell'}>*/}
                          {/*  <div>{" From "}</div>*/}
                          {/*</td>*/}
                          {/*<td className={'open-close-time-cell'}>*/}
                          {/*  <div>*/}
                          {/*    <TimePicker defaultValue={(openFriTime===null||openFriTime===undefined||openFriTime==="")?null:moment(openFriTime, format)} format={format} disabled={ activation_fri } onChange={ this.onChangeTime_Fri_O } />*/}
                          {/*  </div>*/}
                          {/*</td>*/}
                          {/*<td className={'open-close-time-cell'}>*/}
                          {/*  <div>{" To "}</div>*/}
                          {/*</td>*/}
                          {/*<td className={'open-close-time-cell'}>*/}
                          {/*  <div>*/}
                          {/*    <TimePicker defaultValue={(closeFriTime===null||closeFriTime===undefined||closeFriTime==="")?null:moment(closeFriTime, format)} format={format} disabled={ activation_fri } onChange={ this.onChangeTime_Fri_C } />*/}
                          {/*  </div>*/}
                          {/*</td>*/}
                        </tr>
                        <tr className={'open-close-time-row'}>
                          <td className={'open-close-time-cell'}>
                            <div className={'lbl-title'}>Sat</div>
                          </td>
                          <td className={'open-close-time-cell'}>
                            <div>
                              <Radio toggle defaultChecked={ activeSatTime } onChange={ ()=>this.onChangeActivation("SAT") } />
                            </div>
                          </td>
                          {/*<td className={'open-close-time-cell'}>*/}
                          {/*  <div>{" From "}</div>*/}
                          {/*</td>*/}
                          {/*<td className={'open-close-time-cell'}>*/}
                          {/*  <div>*/}
                          {/*    <TimePicker defaultValue={(openSatTime===null||openSatTime===undefined||openSatTime==="")?null:moment(openSatTime, format)} format={format} disabled={ activation_sat } onChange={ this.onChangeTime_Sat_O } />*/}
                          {/*  </div>*/}
                          {/*</td>*/}
                          {/*<td className={'open-close-time-cell'}>*/}
                          {/*  <div>{" To "}</div>*/}
                          {/*</td>*/}
                          {/*<td className={'open-close-time-cell'}>*/}
                          {/*  <div>*/}
                          {/*    <TimePicker defaultValue={(closeSatTime===null||closeSatTime===undefined||closeSatTime==="")?null:moment(closeSatTime, format)} format={format} disabled={ activation_sat } onChange={ this.onChangeTime_Sat_C } />*/}
                          {/*  </div>*/}
                          {/*</td>*/}
                        </tr>
                        <tr className={'open-close-time-row'}>
                          <td className={'open-close-time-cell'}>
                            <div className={'lbl-title'}>Sun</div>
                          </td>
                          <td className={'open-close-time-cell'}>
                            <div>
                              <Radio toggle defaultChecked={ activeSunTime } onChange={ ()=>this.onChangeActivation("SUN") } />
                            </div>
                          </td>
                          {/*<td className={'open-close-time-cell'}>*/}
                          {/*  <div>{" From "}</div>*/}
                          {/*</td>*/}
                          {/*<td className={'open-close-time-cell'}>*/}
                          {/*  <div>*/}
                          {/*    <TimePicker defaultValue={(openSunTime===null||openSunTime===undefined||openSunTime==="")?null:moment(openSunTime, format)} format={format} disabled={ activation_sun } onChange={ this.onChangeTime_Sun_O } />*/}
                          {/*  </div>*/}
                          {/*</td>*/}
                          {/*<td className={'open-close-time-cell'}>*/}
                          {/*  <div>{" To "}</div>*/}
                          {/*</td>*/}
                          {/*<td className={'open-close-time-cell'}>*/}
                          {/*  <div>*/}
                          {/*    <TimePicker defaultValue={(closeSunTime===null||closeSunTime===undefined||closeSunTime==="")?null:moment(closeSunTime, format)} format={format} disabled={ activation_sun } onChange={ this.onChangeTime_Sun_C } />*/}
                          {/*  </div>*/}
                          {/*</td>*/}
                        </tr>
                      </tbody>
                    </table>

                  </div>

                  <div className={'text-right'}>
                    <Button
                      className="px-5"
                      onClick={this.createWorkSpace}
                    >
                      Create
                    </Button>
                  </div>

                </Col>
              </Row>
            </div>

          </MDBModalBody>
        </MDBModal>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  usr_obj: state.userReducer.user,
});

const mapDispatchToProps = (dispatch) => {
  return {
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CreateWorkSpace));
